import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import DesktopTabbedView from "./DesktopTabbedView";
import MobileTabbedView from "./MobileTabbedView";
import { setActiveHeaderTab } from "../../../redux/headerTabsSlice";
import { setData, setCopyData } from "../../../redux/dataSlice";

const ExpenseCategoryTabs = () => {
  const secondCopyData = useSelector((state) => state.data.secondCopyData);
  const activeHeaderTab = useSelector(
    (state) => state.activeHeaderTab.activeHeaderTab
  );
  const dispatch = useDispatch();

  const headerTabs = [
    {
      name: "Expenses",
      key: "expenses",
      data: secondCopyData?.expenses,
    },
    {
      name: "Loan Expenses",
      key: "loanExpenses",
      data: secondCopyData?.loanExpenses,
    },
    {
      name: "Pending Expenses",
      key: "pendingExpenses",
      data: secondCopyData?.pendingExpenses,
    },
  ];

  const handleTabClick = (key, data) => {
    if (activeHeaderTab !== key) {
      dispatch(setActiveHeaderTab(key));
      dispatch(setData(data));
      dispatch(setCopyData(data));
    }
  };

  const isDesktop = window.innerWidth > 999;

  useEffect(() => {
    dispatch(setActiveHeaderTab("expenses"));
  }, []);

  return (
    <>
      {isDesktop ? (
        <DesktopTabbedView
          headerTabs={headerTabs}
          handleTabClick={handleTabClick}
        />
      ) : (
        <MobileTabbedView
          headerTabs={headerTabs}
          handleTabClick={handleTabClick}
        />
      )}
    </>
  );
};

export default ExpenseCategoryTabs;
